import React, { Component } from 'react';
import InformationIcon from "../../../assets/icons/information_icon.svg";
import BackIcon from "../../../assets/icons/back_icon.svg";
import { injectIntl } from 'react-intl';

class BackButton extends Component {
    render() {
        const {
            onPressed,
            intl
        } = this.props;
        
        return (
            <div
                onClick={()=>{
                    onPressed()
                }}
                style = {{
                    display: "flex",
                    alignItems: "center",
                    height: "12%",
                    cursor: "pointer", 
                }}
            >
                <img src={BackIcon} alt = "Back" style = {{
                    marginRight: "2%",
                    height: 14,
                }}/>
                <p style = {{
                    margin: "0% 3% 0% 0%",
                    fontWeight: 400,
                    fontFamily: "Roboto",
                    fontSize: 16,
                }}>
                    {intl.formatMessage({id: "upload-folder-header-back"})}
                </p>
                <img src={InformationIcon} alt = "Information" style = {{cursor: "pointer", width: 18, height: 18}}/>
            </div>
        );
    }
}
export default injectIntl(BackButton);
